import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.0",
  "description": "Turborepo 2.0 is a milestone for the ergonomics of JavaScript and TypeScript monorepos.",
  "date": "2024/6/4",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 2.0 improves the developer experience of JavaScript and TypeScript repositories, with features including:"
  }, {
    "heading": "",
    "content": "New terminal UI: Interactive tasks and clearer logs"
  }, {
    "heading": "",
    "content": "Watch Mode: Dependency-aware task watcher for any tooling in your repository"
  }, {
    "heading": "",
    "content": "All-new documentation: Core monorepo concepts, refreshed API reference, and ecosystem tooling guides"
  }, {
    "heading": "",
    "content": "Licensing and maintenance updates: Upgraded to MIT license and added Long Term Support policy"
  }, {
    "heading": "",
    "content": "Update today by running npx @turbo/codemod migrate or get started with npx create-turbo@latest."
  }, {
    "heading": "",
    "content": "Visit the upgrading guide for update instructions. Breaking changes are listed below."
  }, {
    "heading": "new-terminal-ui",
    "content": "In Turborepo 1.13, we released an experimental interface to learn how a refined terminal UI could improve development velocity. Through the RFC process, we were able to work with the community on designing a revamped local experience, driven by your feedback. Thank you to those who participated."
  }, {
    "heading": "new-terminal-ui",
    "content": "Today, we’re releasing the new UI as stable, along with the highly requested features that it enables."
  }, {
    "heading": "improved-clarity-for-logs",
    "content": "Before 2.0, turbo would output logs as a stream while you were working on your libraries and applications. This could be overwhelming at times, since the intermixed logs made it difficult to understand what was going on with a specific task."
  }, {
    "heading": "improved-clarity-for-logs",
    "content": "In this iteration of the UI, you can select individual tasks using your arrow keys to inspect their logs one at a time, making it easier to read the logs that you want to focus on."
  }, {
    "heading": "improved-clarity-for-logs",
    "content": "The streamed logs view from prior versions of turbo is still available for\nlocal development by using the --log-order flag. Note that tasks will not be\ninteractive with this option and some tools may clear the terminal\nunexpectedly."
  }, {
    "heading": "interactive-tasks",
    "content": "Many tools allow for interacting with a script for important functionality. But, in previous versions of Turborepo, your scripts were trapped inside turbo so you couldn’t interact with them."
  }, {
    "heading": "interactive-tasks",
    "content": "You can now enter the shell of individual tasks and pass inputs to your scripts via stdin by typing directly into the interface. This enables workflows like running specific test suites with Jest or Vitest, handling database migrations with Drizzle or Prisma, and much more."
  }, {
    "heading": "interactive-tasks",
    "content": "To mark a task as interactive, add \"persistent\": true to its definition:"
  }, {
    "heading": "interactive-tasks",
    "content": "With the task selected in the UI, use the Enter key to enter the task’s shell and CTRL+Z to exit."
  }, {
    "heading": "interactive-tasks",
    "content": "To learn more about persistent and interactive tasks, visit the documentation."
  }, {
    "heading": "watch-mode",
    "content": "Turborepo's ability to run many tasks at once gives you tighter feedback loops that help you ship faster. To get the most out of Turborepo's parallelization when working locally, your tools need to have a \"watcher\" feature available to re-run your code whenever you make changes. Unfortunately, many common tools don't, and most tools aren't monorepo-aware, leading to problems with scripts that depend on other scripts in your repository."
  }, {
    "heading": "watch-mode",
    "content": "Today, we're releasing Watch Mode to bring this functionality to all your tooling:"
  }, {
    "heading": "watch-mode",
    "content": "Using turbo watch, Turborepo will re-run tasks whenever you make changes to your source code. Tasks will be run using your dependency graph and configuration from turbo.json, just like turbo run."
  }, {
    "heading": "watch-mode",
    "content": "Learn more about Watch Mode in the documentation."
  }, {
    "heading": "all-new-documentation",
    "content": "With this release, we’re also publishing revitalized documentation that builds on the strengths of prior versions. We’ve heard your feedback, so the docs now include:"
  }, {
    "heading": "all-new-documentation",
    "content": "More monorepo fundamentals and how-tos"
  }, {
    "heading": "all-new-documentation",
    "content": "Guides on integrating your favorite tools with Turborepo"
  }, {
    "heading": "all-new-documentation",
    "content": "Clearer information architecture and improved search"
  }, {
    "heading": "all-new-documentation",
    "content": "Visit the Turborepo documentation."
  }, {
    "heading": "breaking-changes",
    "content": "Visit the upgrading guide for instructions on how to update to 2.0."
  }, {
    "heading": "configuration",
    "content": "Breaking changes for turbo.json can be updated using npx @turbo/codemod\n  migrate."
  }, {
    "heading": "configuration",
    "content": "Ignore turbo field in package.json (PR)"
  }, {
    "heading": "configuration",
    "content": "Turborepo’s default disk cache location moved to .turbo/cache from node_modules/.cache (PR)"
  }, {
    "heading": "configuration",
    "content": "pipeline key in turbo.json renamed to tasks (PR)"
  }, {
    "heading": "configuration",
    "content": "File globs for directories in inputs/outputs include the directory's contents (e.g. dist anddist/ equal dist/**) (PR)"
  }, {
    "heading": "configuration",
    "content": "outputMode key renamed to outputLogs for clarity and to match the --output-logs flag (PR)"
  }, {
    "heading": "configuration",
    "content": "This change will be reflected in Run Summaries in resolvedTaskConfig"
  }, {
    "heading": "configuration",
    "content": "Error on environment variable syntax in dependsOn and globalDependencies (deprecated since 1.4) (PR)"
  }, {
    "heading": "configuration",
    "content": "globalDotEnv and dotEnv removed in favor of including .env files in inputs (PR)"
  }, {
    "heading": "configuration",
    "content": "--ignore removed in favor of --filter and graph correctness changes below (PR)"
  }, {
    "heading": "correctness",
    "content": "Strict Mode for environment variables is now the default, moving from Loose Mode (PR)"
  }, {
    "heading": "correctness",
    "content": "Workspace root directory is now an implicit dependency of all packages (PR)"
  }, {
    "heading": "correctness",
    "content": "Removed --scope flag (deprecated since 1.2) (PR)"
  }, {
    "heading": "correctness",
    "content": "Packages must have a name in package.json (PR)"
  }, {
    "heading": "correctness",
    "content": "packageManager field in root package.json is now required (PR)"
  }, {
    "heading": "correctness",
    "content": "engines field in root package.json is now used in hashing (PR)"
  }, {
    "heading": "correctness",
    "content": "--filter no longer infers namespaces for package names (PR)"
  }, {
    "heading": "correctness",
    "content": "--filter now errors when no package names or directories are matched (PR)"
  }, {
    "heading": "correctness",
    "content": "--only restricts task dependencies instead of only package dependencies (PR)"
  }, {
    "heading": "other",
    "content": "Minimum package manager version support for npm and pnpm updated to 8 (Source)"
  }, {
    "heading": "other",
    "content": "Remove package manager argument from create-turbo, replaced by option (PR)"
  }, {
    "heading": "community",
    "content": "We're excited to see the continued growth and adoption of Turborepo:"
  }, {
    "heading": "community",
    "content": "25.2k+ GitHub Stars"
  }, {
    "heading": "community",
    "content": "2.3m+ weekly NPM downloads"
  }, {
    "heading": "community",
    "content": "347 years of compute time saved using Vercel Remote Cache"
  }, {
    "heading": "community",
    "content": "Turborepo is the result of the combined work of all of its contributors, including our core team: Anthony, Chris, Greg, Mehul, Mitch, Nicholas, and Tom."
  }, {
    "heading": "community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice. If you haven't already, join the conversation on GitHub and Discord."
  }],
  "headings": [{
    "id": "new-terminal-ui",
    "content": "New terminal UI"
  }, {
    "id": "improved-clarity-for-logs",
    "content": "Improved clarity for logs"
  }, {
    "id": "interactive-tasks",
    "content": "Interactive tasks"
  }, {
    "id": "watch-mode",
    "content": "Watch Mode"
  }, {
    "id": "all-new-documentation",
    "content": "All-new documentation"
  }, {
    "id": "breaking-changes",
    "content": "Breaking changes"
  }, {
    "id": "configuration",
    "content": "Configuration"
  }, {
    "id": "correctness",
    "content": "Correctness"
  }, {
    "id": "other",
    "content": "Other"
  }, {
    "id": "community",
    "content": "Community"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Callout} from '#components/callout';
import {Video} from '#components/video';
export const toc = [{
  depth: 2,
  url: "#new-terminal-ui",
  title: _jsx(_Fragment, {
    children: "New terminal UI"
  })
}, {
  depth: 3,
  url: "#improved-clarity-for-logs",
  title: _jsx(_Fragment, {
    children: "Improved clarity for logs"
  })
}, {
  depth: 3,
  url: "#interactive-tasks",
  title: _jsx(_Fragment, {
    children: "Interactive tasks"
  })
}, {
  depth: 2,
  url: "#watch-mode",
  title: _jsx(_Fragment, {
    children: "Watch Mode"
  })
}, {
  depth: 2,
  url: "#all-new-documentation",
  title: _jsx(_Fragment, {
    children: "All-new documentation"
  })
}, {
  depth: 2,
  url: "#breaking-changes",
  title: _jsx(_Fragment, {
    children: "Breaking changes"
  })
}, {
  depth: 3,
  url: "#configuration",
  title: _jsx(_Fragment, {
    children: "Configuration"
  })
}, {
  depth: 3,
  url: "#correctness",
  title: _jsx(_Fragment, {
    children: "Correctness"
  })
}, {
  depth: 3,
  url: "#other",
  title: _jsx(_Fragment, {
    children: "Other"
  })
}, {
  depth: 2,
  url: "#community",
  title: _jsx(_Fragment, {
    children: "Community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 2.0"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, June 4, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['chrisolszewski', 'nicholasyang']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.0 improves the developer experience of JavaScript and TypeScript repositories, with features including:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#new-terminal-ui",
          children: _jsx(_components.strong, {
            children: "New terminal UI"
          })
        }), ": Interactive tasks and clearer logs"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#watch-mode",
          children: _jsx(_components.strong, {
            children: "Watch Mode"
          })
        }), ": Dependency-aware task watcher for any tooling in your repository"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#all-new-documentation",
          children: _jsx(_components.strong, {
            children: "All-new documentation"
          })
        }), ": Core monorepo concepts, refreshed API reference, and ecosystem tooling guides"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Licensing and maintenance updates"
        }), ": Upgraded to MIT license and added ", _jsx(_components.a, {
          href: "/docs/support-policy#lts-policy",
          children: "Long Term Support policy"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), " or get started with ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Visit ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/upgrading#upgrading-to-20",
        children: "the upgrading guide"
      }), " for update instructions. ", _jsx(_components.a, {
        href: "#breaking-changes",
        children: "Breaking changes"
      }), " are listed below."]
    }), "\n", _jsx(_components.h2, {
      id: "new-terminal-ui",
      children: "New terminal UI"
    }), "\n", _jsxs(_components.p, {
      children: ["In ", _jsx(_components.a, {
        href: "https://turborepo.com/blog/turbo-1-13-0",
        children: "Turborepo 1.13"
      }), ", we released an experimental interface to learn how a refined terminal UI could improve development velocity. Through ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/discussions/7802",
        children: "the RFC process"
      }), ", we were able to work with the community on designing a revamped local experience, driven by your feedback. Thank you to those who participated."]
    }), "\n", _jsx(_components.p, {
      children: "Today, we’re releasing the new UI as stable, along with the highly requested features that it enables."
    }), "\n", _jsx(Video, {
      src: "/images/blog/turbo-2-0/interactive-ui.mp4",
      width: "928",
      height: "522",
      className: "rounded"
    }), "\n", _jsx(_components.h3, {
      id: "improved-clarity-for-logs",
      children: "Improved clarity for logs"
    }), "\n", _jsxs(_components.p, {
      children: ["Before 2.0, ", _jsx(_components.code, {
        children: "turbo"
      }), " would output logs as a stream while you were working on your libraries and applications. This could be overwhelming at times, since the intermixed logs made it difficult to understand what was going on with a specific task."]
    }), "\n", _jsx(_components.p, {
      children: "In this iteration of the UI, you can select individual tasks using your arrow keys to inspect their logs one at a time, making it easier to read the logs that you want to focus on."
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: ["The streamed logs view from prior versions of ", _jsx(_components.code, {
          children: "turbo"
        }), " is still available for\nlocal development by using the ", _jsx(_components.code, {
          children: "--log-order"
        }), " flag. Note that tasks will not be\ninteractive with this option and some tools may clear the terminal\nunexpectedly."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "interactive-tasks",
      children: "Interactive tasks"
    }), "\n", _jsxs(_components.p, {
      children: ["Many tools allow for interacting with a script for important functionality. But, in previous versions of Turborepo, your scripts were trapped inside ", _jsx(_components.code, {
        children: "turbo"
      }), " so you couldn’t interact with them."]
    }), "\n", _jsxs(_components.p, {
      children: ["You can now enter the shell of individual tasks and pass inputs to your scripts via ", _jsx(_components.code, {
        children: "stdin"
      }), " by typing directly into the interface. This enables workflows like running specific test suites with ", _jsx(_components.a, {
        href: "https://jestjs.io",
        children: "Jest"
      }), " or ", _jsx(_components.a, {
        href: "https://vitest.dev/",
        children: "Vitest"
      }), ", handling database migrations with ", _jsx(_components.a, {
        href: "https://orm.drizzle.team/",
        children: "Drizzle"
      }), " or ", _jsx(_components.a, {
        href: "https://www.prisma.io/",
        children: "Prisma"
      }), ", and much more."]
    }), "\n", _jsxs(_components.p, {
      children: ["To mark a task as interactive, add ", _jsx(_components.code, {
        children: "\"persistent\": true"
      }), " to its definition:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["With the task selected in the UI, use the ", _jsx(_components.code, {
        children: "Enter"
      }), " key to enter the task’s shell and ", _jsx(_components.code, {
        children: "CTRL+Z"
      }), " to exit."]
    }), "\n", _jsxs(_components.p, {
      children: ["To learn more about persistent and interactive tasks, ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: "visit the documentation"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "watch-mode",
      children: "Watch Mode"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo's ability to run many tasks at once gives you tighter feedback loops that help you ship faster. To get the most out of Turborepo's parallelization when working locally, your tools need to have a \"watcher\" feature available to re-run your code whenever you make changes. Unfortunately, many common tools don't, and most tools aren't monorepo-aware, leading to problems with scripts that depend on other scripts in your repository."
    }), "\n", _jsx(_components.p, {
      children: "Today, we're releasing Watch Mode to bring this functionality to all your tooling:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Using ", _jsx(_components.code, {
        children: "turbo watch"
      }), ", Turborepo will re-run tasks whenever you make changes to your source code. Tasks will be run using your dependency graph and configuration from ", _jsx(_components.code, {
        children: "turbo.json"
      }), ", just like ", _jsx(_components.code, {
        children: "turbo run"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "/docs/crafting-your-repository/developing-applications#watch-mode",
        children: "Learn more about Watch Mode in the documentation."
      })
    }), "\n", _jsx(_components.h2, {
      id: "all-new-documentation",
      children: "All-new documentation"
    }), "\n", _jsx(_components.p, {
      children: "With this release, we’re also publishing revitalized documentation that builds on the strengths of prior versions. We’ve heard your feedback, so the docs now include:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "More monorepo fundamentals and how-tos"
      }), "\n", _jsx(_components.li, {
        children: "Guides on integrating your favorite tools with Turborepo"
      }), "\n", _jsx(_components.li, {
        children: "Clearer information architecture and improved search"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "/docs",
        children: "Visit the Turborepo documentation."
      })
    }), "\n", _jsx(_components.h2, {
      id: "breaking-changes",
      children: "Breaking changes"
    }), "\n", _jsxs(_components.p, {
      children: ["Visit ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/upgrading#upgrading-to-20",
        children: "the upgrading guide"
      }), " for instructions on how to update to 2.0."]
    }), "\n", _jsx(_components.h3, {
      id: "configuration",
      children: "Configuration"
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["Breaking changes for ", _jsx(_components.code, {
          children: "turbo.json"
        }), " can be updated using ", _jsx(_components.code, {
          children: "npx @turbo/codemod   migrate"
        }), "."]
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Ignore ", _jsx(_components.code, {
          children: "turbo"
        }), " field in ", _jsx(_components.code, {
          children: "package.json"
        }), " (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8023",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Turborepo’s default disk cache location moved to ", _jsx(_components.code, {
          children: ".turbo/cache"
        }), " from ", _jsx(_components.code, {
          children: "node_modules/.cache"
        }), " (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8126",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "pipeline"
        }), " key in ", _jsx(_components.code, {
          children: "turbo.json"
        }), " renamed to ", _jsx(_components.code, {
          children: "tasks"
        }), " (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8157",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["File globs for directories in ", _jsx(_components.code, {
          children: "inputs"
        }), "/", _jsx(_components.code, {
          children: "outputs"
        }), " include the directory's contents (e.g. ", _jsx(_components.code, {
          children: "dist"
        }), " and", _jsx(_components.code, {
          children: "dist/"
        }), " equal ", _jsx(_components.code, {
          children: "dist/**"
        }), ") (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8180",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "outputMode"
        }), " key renamed to ", _jsx(_components.code, {
          children: "outputLogs"
        }), " for clarity and to match the ", _jsx(_components.code, {
          children: "--output-logs"
        }), " flag (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8149",
          children: "PR"
        }), ")", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["This change will be reflected in Run Summaries in ", _jsx(_components.code, {
              children: "resolvedTaskConfig"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Error on environment variable syntax in ", _jsx(_components.code, {
          children: "dependsOn"
        }), " and ", _jsx(_components.code, {
          children: "globalDependencies"
        }), " (deprecated since 1.4) (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8026",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "globalDotEnv"
        }), " and ", _jsx(_components.code, {
          children: "dotEnv"
        }), " removed in favor of including ", _jsx(_components.code, {
          children: ".env"
        }), " files in ", _jsx(_components.code, {
          children: "inputs"
        }), " (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8181",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--ignore"
        }), " removed in favor of ", _jsx(_components.code, {
          children: "--filter"
        }), " and graph correctness changes below (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8201",
          children: "PR"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "correctness",
      children: "Correctness"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Strict Mode for environment variables is now the default, moving from Loose Mode (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8182",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Workspace root directory is now an implicit dependency of all packages (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8202",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Removed ", _jsx(_components.code, {
          children: "--scope"
        }), " flag (deprecated since 1.2) (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7970",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Packages must have a ", _jsx(_components.code, {
          children: "name"
        }), " in ", _jsx(_components.code, {
          children: "package.json"
        }), " (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8152",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "packageManager"
        }), " field in root ", _jsx(_components.code, {
          children: "package.json"
        }), " is now required (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8017",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "engines"
        }), " field in root ", _jsx(_components.code, {
          children: "package.json"
        }), " is now used in hashing (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8173",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter"
        }), " no longer infers namespaces for package names (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8137",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter"
        }), " now errors when no package names or directories are matched (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8142",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--only"
        }), " restricts task dependencies instead of only package dependencies (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8163",
          children: "PR"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "other",
      children: "Other"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Minimum package manager version support for npm and pnpm updated to 8 (", _jsx(_components.a, {
          href: "/docs/support-policy#package-managers",
          children: "Source"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Remove package manager argument from ", _jsx(_components.code, {
          children: "create-turbo"
        }), ", replaced by option (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8150",
          children: "PR"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "community",
      children: "Community"
    }), "\n", _jsx(_components.p, {
      children: "We're excited to see the continued growth and adoption of Turborepo:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "25.2k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "2.3m+ weekly NPM downloads"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["347 years of compute time saved using ", _jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel Remote Cache"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo is the result of the combined work of all of its contributors, including our core team: ", _jsx(_components.a, {
        href: "https://github.com/anthonyshew",
        children: "Anthony"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/chris-olszewski",
        children: "Chris"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/gsoltis",
        children: "Greg"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/mehulkar",
        children: "Mehul"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/Zertsov",
        children: "Mitch"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/NicholasLYang",
        children: "Nicholas"
      }), ", and ", _jsx(_components.a, {
        href: "https://github.com/tknickman",
        children: "Tom"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice. If you haven't already, join the conversation on ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo",
        children: "GitHub"
      }), " and ", _jsx(_components.a, {
        href: "/discord",
        children: "Discord"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
